import React from 'react';
import { FormField, TextInput, NavButtons } from './QuoteFormField';

export default function QuoteStepPriorInsurance({ form, onChange, onNext, onBack }) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-2">Prior Insurance</h2>
        <p className="text-gray-500">Tell us about your current or most recent coverage.</p>
      </div>

      <FormField label="Prior Carrier Name">
        <TextInput
          value={form.prior_carrier}
          onChange={val => onChange({ prior_carrier: val })}
          placeholder="e.g. AAA, State Farm, Allstate"
        />
      </FormField>

      <FormField label="Prior Policy Expiration Date">
        <TextInput
          type="date"
          value={form.prior_policy_expiration}
          onChange={val => onChange({ prior_policy_expiration: val })}
        />
      </FormField>

      <FormField label="Years Continuously Insured">
        <TextInput
          type="number"
          value={form.years_continuously_insured}
          onChange={val => onChange({ years_continuously_insured: val })}
          placeholder="e.g. 8"
        />
      </FormField>

      <NavButtons onBack={onBack} onNext={onNext} />
    </div>
  );
}
